import module from '../../models/AxiosModule'
const axios = module.Axios


import { DELETE_REPORT, REPORTS_DOWNLOAD, REPORTS_GET } from '../actions/reports'

const state = {
  reports: '',

}

const getters = {
  getReports: state => state.reports,

}





const actions = {
  [REPORTS_GET]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      axios.post('get-reports', {}).then(response => {
        commit(REPORTS_GET, response.data.reports)
        resolve()

      })
      // commit(INTRO_BY_SOCIAL, data)


    })
  },
  [REPORTS_DOWNLOAD]: ({ commit, dispatch }, { hashId, type }) => {
    return new Promise((resolve, reject) => {

      axios.post('download-report',
        {
          hashId, type,
        },
        {
          responseType: 'blob'
        }
      ).then(response => {
        resolve(response)
      })


    })
  },
  [DELETE_REPORT]: ({ commit, dispatch, getters }, { id, type }) => {
    return new Promise((resolve, reject) => {
      axios.post('delete-report', { id, type }).then(response => {
        const updateReports = getters.getReports.filter(report => report.id != id)
        commit(REPORTS_GET, updateReports)
        resolve()

      })


    })
  },




}

const mutations = {
  [REPORTS_GET]: (state, resp) => {
    state.reports = resp
  },
  // [INTRO_SET_PAGES]: (state, resp) => {
  //     state.pages = JSON.parse(JSON.stringify(resp))
  // },

}

export default {
  state,
  getters,
  actions,
  mutations,
}